import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';

/**
 * Focusable, named `info` affordance: a real `<button>` (not a plain
 * `<mat-icon>` with a click handler) carrying an explicit accessible
 * name plus a `matTooltip`. Replaces every ad hoc `pTooltip`/unnamed
 * `mat-icon` "info" pattern across the app so icon actions are keyboard-
 * operable and have an accessible name.
 */
@Component({
  selector: 'app-info-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './info-icon.component.html',
  styleUrl: './info-icon.component.scss',
})
export class InfoIconComponent {
  /** Accessible name — required so the control is never unnamed. */
  @Input({ required: true }) label = '';
  /** Tooltip text; falls back to `label` when not provided. */
  @Input() tooltip = '';
  @Input() tooltipPosition: TooltipPosition = 'right';
  @Input() icon = 'info';
  @Input() testId?: string;

  get resolvedTooltip(): string {
    return this.tooltip || this.label;
  }
}
